<template>
  <div class="section-block">
    <div class="block1-list">
      <van-list v-model="postState.loading" :finished="postState && postState.finished" :finished-text="postState.finishText"
        @load="handleGetPostList">
        <div v-if="postListArr.length > 0">
          <div class="block1-item" v-for="(item, index) in postListArr" :key="index" @click="handleClickItems(item)">
            <img src="@/assets/images/zone/img25.png"
              v-if="item.areaPostbarWorkDataDTOS && item.areaPostbarWorkDataDTOS.length > 0" class="icon-tag" alt="" />
            <img src="@/assets/images/zone/img24.png"
              v-else-if="item.areaPostbarWorkDataDTOS && item.areaPostbarWorkDataDTOS.length <= 0" class="icon-tag"
              alt="" />
            <div class="item-top">
              <img :src="item && item.headPicUrl" class="top-cover" alt="" />
              <div class="top-con">
                <div class="txt1" v-if="`${item.userIdentity}` === '2'">
                  管理员
                </div>
                <div class="txt1 txt2" v-else>{{ item && item.realName }}</div>
                <div class="txt2">
                  <span class="txt2-tag tag-admin" v-if="`${item.userIdentity}` === '2' && `${item.type }` === '4'">{{ item.tutorName ? `代${item.tutorName}导师发布` : '代专区导师发布' }}</span>
                  <span class="txt2-tag tag2" v-else-if="`${item.userIdentity}` === '1'">{{ userTypeObj[item.userIdentity] }}</span>
                  <span class="txt2-tag tag-user" v-else>{{ userTypeObj[item.userIdentity] }}</span>
                  <span class="txt2-time">{{ item && item.times }}</span>
                </div>
              </div>
            </div>
            <div class="con-div">
              <div class="item-title">{{ item && item.subjectName }}</div>
              <div class="item-cons" v-html="item.content"></div>
              <div class="item-imgs" v-if="item.contentFile && item.contentFile.length > 0">
                <div class="imgs-mask" v-if="item && item.isMoreImgs">
                  +{{ item && item.moreNum }}
                </div>
                <img v-for="(item_img, index_img) in item.contentFile" :key="index_img" :src="item_img.url"
                  class="img-cover" alt="" />
              </div>
              <div class="item-imgs" v-if="item.videoInfo && Object.keys(item.videoInfo).length > 0">
                <div class="video-block" v-if="!item.isPlayVideo" @click.stop="handleClickItemsVideo(item, index)">
                  <div v-if="item && item.coverInfo" :style="`background-image: url(${item.coverInfo.url});`"
                    class="video-cover" alt=""></div>
                  <div v-else :style="`background-image: url(${item.videoInfo.outUrl || item.videoInfo.path});`"
                    class="video-cover" alt=""></div>
                  <img src="@/assets/images/course/icon-play-course.png" class="icon-video" alt="" />
                </div>
                <VideoPlayerAnswer v-else ref="video" @handlePlay="handlePlay" :playerVideo="item && item.videoInfo">
                </VideoPlayerAnswer>
                <!-- <img :src="item.videoInfo.outUrl || item.videoInfo.path" class="video-cover" alt="">
                <img src="@/assets/images/course/icon-play-course.png" class="icon-video" alt=""> -->
              </div>
              <template v-if="item.voteListSelectedDTOS && item.voteListSelectedDTOS.length > 0">
                <div class="vote-list">
                  <div class="vote-show-div" :class="item.voteAll ? 'auto' : ''">
                    <div class="vote-item" v-for="(item_vote, index_vote) in item.voteListSelectedDTOS"
                      :key="index_vote" :class="item_vote.isSelected ? 'item-checked' : 'item-not-checked'"
                      @click.stop="handleClickVoteItems(index, index_vote)">
                      <div class="txt-block">
                        <span class="txt">
                          {{ item_vote && item_vote.content }}
                        </span>
                        <img v-if="item_vote && item_vote.isSelected" src="@/assets/images/zone/img39.png" :style="`left: ${(item_vote.content.length + 1) * 17}px;`" class="icon-checked" alt="">
                      </div>
                      <div class="process" :style="`width: ${item_vote.selectNum / item.allVotePerson * 100}%;`"></div>
                      <span class="num-txt">{{ item_vote && item_vote.selectNum }}</span>
                    </div>
                  </div>
                  <!-- <div class="vote-item item-not-checked">
                    <span class="txt">U波明显</span>
                    <div class="process"></div>
                    <span class="num-txt">37</span>
                  </div> -->
                  <div class="vote-item" v-if="!item.voteAll && item.voteListSelectedDTOS.length > 3"
                    @click.stop="handleClickAll(index)">
                    查看全部选项
                    <img src="@/assets/images/zone/img38.png" class="icon-more" alt="">
                  </div>
                  <div v-else-if="item.isChecked" class="vote-item item-submit" @click.stop="handleSubmitVote(index)">提交</div>
                </div>
                <div class="work-tip">
                  <div class="left-txt">{{ item && item.cutTimeStr }}</div>
                  <div class="right-txt">{{ item.voteNum > 0 ? item.voteNum : 0 }}人参与</div>
                </div>
              </template>
              <template v-else>
                <div class="item-imgs" v-if="item.areaPostbarLiveDTOS && item.areaPostbarLiveDTOS.length > 0">
                  <div v-for="(item_live, index_live) in item.areaPostbarLiveDTOS" :key="index_live" class="div-con">
                    <div class="live-img-div">
                      <img :src="item_live.liveCover" class="video-cover" alt="">
                    </div>
                    <div class="bg-div"></div>
                    <div class="items-con">
                      <div class="con-txt">{{ item_live.liveTitle }}</div>
                      <div class="con-btn" v-track="{ functionName: 'RTC专区-RTC专区详情-交流专区-直播' }" @click.stop="handleClickLive(item_live)">进入</div>
                    </div>
                  </div>
                </div>
                <div class="item-comment" v-if="item.commentDTOS.length > 0" @click="handleClickItems(item, 'comment')">
                  <div class="comment-block" v-for="(item_comm, index_comm) in item.commentDTOS" :key="index_comm">
                    <img :src="item_comm.headPicUrl" class="head-cover" alt="">
                    <div class="comment-txt">{{ item_comm.content }}</div>
                  </div>
                </div>
                <div class="work-div" v-if="item.areaPostbarWorkDataDTOS && item.areaPostbarWorkDataDTOS.length > 0">
                  <img src="@/assets/images/zone/img22.png" class="icon-word" alt="">
                  <div class="work-txt">关联内容</div>
                  <div class="work-go">
                    <div class="txt">
                      {{ item.areaPostbarWorkDataDTOS[0].title }}
                    </div>
                    <img src="@/assets/images/zone/img23.png" class="icon-more" alt="">
                  </div>
                </div>
                <template
                  v-else-if="item.areaPostbarWorkDataDTOS && item.areaPostbarWorkDataDTOS.length <= 0 && (`${rolesData.tutorSign}` !== '1' || (`${rolesData.tutorSign}` === '1' && (!item.tutorId || item.tutorId === userInfo.id)))">
                  <div class="work-div worked" v-if="`${item.isCutTime}` !== '1' && `${rolesData.studentSign}` === '1'">
                    <img src="@/assets/images/zone/img32.png" class="icon-word" alt="">
                    <div class="work-txt">待办任务作业</div>
                    <div class="work-btn">已过期</div>
                  </div>
                  <div class="work-div"
                    v-else-if="`${userInfo.memberType}` === '0' && item.areaPostbarWorkDataDTOS.length <= 0 && `${rolesData.tutorSign}` === '1'">
                    <img src="@/assets/images/zone/img26.png" class="icon-word" alt="">
                    <div class="work-txt">待办任务作业</div>
                    <div class="work-check" v-if="item.areaPostbarWorkDTO.length > 0"
                      @click.stop="handleClickWork(item, 'workdetails')">
                      <img src="@/assets/images/zone/img31.png" class="icon-check" alt="">
                      <span class="check-txt">已批改</span>
                      <img src="@/assets/images/zone/img23.png" class="icon-more" alt="">
                    </div>
                    <div class="work-btn" @click.stop="handleClickWork(item, 'worklist')" v-else>批作业</div>
                  </div>
                  <div class="work-div"
                    v-else-if="`${userInfo.memberType}` === '0' && item.areaPostbarWorkDataDTOS.length <= 0 && `${rolesData.peSign}` !== '1'">
                    <img src="@/assets/images/zone/img26.png" class="icon-word" alt="">
                    <div class="work-txt">待办任务作业-{{ item.tutorName }}导师</div>
                    <div class="work-check" v-if="item.areaPostbarWorkDTO.length > 0"
                      @click.stop="handleClickWork(item, 'workdetails')">
                      <img src="@/assets/images/zone/img31.png" class="icon-check" alt="">
                      <span class="check-txt">已作答</span>
                      <img src="@/assets/images/zone/img23.png" class="icon-more" alt="">
                    </div>
                    <div class="work-btn" @click.stop="handleClickWork(item, 'answerwork')" v-else>去完成</div>
                  </div>
                  <div class="work-div" v-else-if="`${userInfo.memberType}` === '1' || `${rolesData.peSign}` === '1'">
                    <img src="@/assets/images/zone/img26.png" class="icon-word" alt="">
                    <div class="work-txt">待办任务作业</div>
                    <div class="work-btn" @click.stop="handleClickWork(item, 'worklist')">查看</div>
                  </div>
                  <div class="work-tip" v-if="item.areaPostbarWorkDataDTOS.length <= 0">
                    <div class="left-txt" v-if="item.curTimes">截止时间:{{ item.curTimes }}</div>
                    <div class="right-txt">{{ item.workFinishNum > 0 ? item.workFinishNum : 0 }}人已完成</div>
                  </div>
                </template>
              </template>
              <div class="item-btm">
                <div class="btm-flex">
                  <img src="@/assets/images/zone/img7.png" class="icon-btm1" alt="" />
                  <span class="btm-num">{{ item.visitNum > 0 ? item.visitNum : 0 }}</span>
                </div>
                <div class="btm-flex">
                  <img src="@/assets/images/zone/img16.png" class="icon-btm1" alt="" />
                  <span class="btm-num">{{ item.commentNum > 0 ? item.commentNum : 0 }}</span>
                </div>
                <div class="btm-flex" @click.stop="handleLike(item, index)">
                  <img src="@/assets/images/zone/img20.png" v-if="item.isLike + '' === '1'" class="icon-btm1" alt="" />
                  <img src="@/assets/images/zone/img17.png" v-if="item.isLike + '' === '2'" class="icon-btm1" alt="" />
                  <span class="btm-num">{{ item.likeNum > 0 ? item.likeNum : 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-block" v-else-if="isNone">
          <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
          <div class="empty-txt">暂无内容</div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { userTypeObj } from '../data'
import { postList, postLike, delLike, votePostSelected, visitAdd } from '@/api/zone'
// import { setSha } from '@/utils/util'
import VideoPlayerAnswer from '../../home/components/VideoPlayerAnswer.vue'
export default {
  props: {
    areaId: '',
    roles: {}
  },
  components: {
    VideoPlayerAnswer
  },
  data () {
    return {
      load: false,
      // 筛选项分页
      postState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      postListArr: [],
      userTypeObj,
      isNone: false,
      searchContent: '',
      rolesData: {},
      // [{"voteId":1231,"postbarId":12313,"userId":13123}]
      voteChanges: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    roles (newval, old) {
      this.rolesData = newval
    }
  },
  mounted () {
    if (this.roles && Object.keys(this.roles).length > 0) {
      this.rolesData = this.roles
    }
  },
  methods: {
    // 点击提交投票
    handleSubmitVote (index) {
      if (this.voteChanges.length <= 0) {
        this.$toast('请至少选择一项或者修改一项！')
        return
      }
      if (`${this.postListArr[index].selectType}` === '2' && this.voteChanges.length <= 1) {
        this.$toast('该投票为多选，请至少选择一个以上！')
        return
      }
      votePostSelected({ voteSelectROS: this.voteChanges }).then(res => {
        this.postListArr[index].isChecked = false
        this.voteChanges = []
        this.$toast('投票成功')
      })
    },
    // 点击选择投票
    handleClickVoteItems (index, indexVote) {
      if (!this.postListArr[index].isChecked) return
      if (`${this.postListArr[index].selectType}` === '2') {
        this.postListArr[index].voteListSelectedDTOS[indexVote].isSelected = !this.postListArr[index].voteListSelectedDTOS[indexVote].isSelected
        if (this.postListArr[index].voteListSelectedDTOS[indexVote].isSelected) {
          this.postListArr[index].voteListSelectedDTOS[indexVote].selectNum++
          this.postListArr[index].allVotePerson++
        } else {
          this.postListArr[index].voteListSelectedDTOS[indexVote].selectNum--
          this.postListArr[index].allVotePerson--
        }
      } else {
        if (this.postListArr[index].voteListSelectedDTOS[indexVote].isSelected) return
        this.postListArr[index].voteListSelectedDTOS[indexVote].selectNum++
        this.postListArr[index].allVotePerson++
        this.postListArr[index].voteListSelectedDTOS.map((res, i) => {
          if (res.isSelected) {
            res.selectNum--
            this.postListArr[index].allVotePerson--
          }
          res.isSelected = false
        })
        this.postListArr[index].voteListSelectedDTOS[indexVote].isSelected = 1
      }
      this.voteChanges = this.postListArr[index].voteListSelectedDTOS.filter(res => res.isSelected).map(res => {
        return {
          voteId: res.id,
          postbarId: res.postbarId,
          userId: this.userInfo.id
        }
      })
    },
    // 投票item展示全部
    handleClickAll (index) {
      this.postListArr[index].voteAll = !this.postListArr[index].voteAll
    },
    handleGetPostList () {
      let params = {
        pageNum: this.postState.pageNo,
        pageSize: this.postState.pageSize,
        areaId: this.areaId,
        searchContent: this.searchContent
      }
      postList(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              return false
            }
            this.postState.finished = false
            this.postState.loading = false
            res.data.list = res.data.list.map(item => {
              item.times = this.$moment(item.auditTime * 1).format('MM-DD HH:mm')
              item.curTimes = item.cutTime ? this.$moment(item.cutTime * 1).format('YYYY/MM/DD HH:mm') : ''
              if (item.contentFile.length > 3) {
                item.isMoreImgs = true
                item.moreNum = item.contentFile.length - 3
              }
              item.contentFile = item.contentFile.splice(0, 3)
              if (item.videoInfo) {
                item.isPlayVideo = false
                item.videoInfo.sectionId = item.videoInfo.id
                item.videoInfo.path = encodeURI(item.videoInfo.path)
                item.videoInfo.outUrl = encodeURI(item.videoInfo.outUrl)
              }
              if (item.voteListSelectedDTOS && item.voteListSelectedDTOS.length > 0) {
                item.allVotePerson = 0
                item.voteListSelectedDTOS.map(items => {
                  item.allVotePerson += items.selectNum
                })
                item.voteAll = !(item.voteListSelectedDTOS.length > 3)
                item.isChecked = !(item.voteListSelectedDTOS.filter(res => res.isSelected).length > 0)
              }
              return item
            })
            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.postListArr = this.postListArr.concat(res.data.list)
            }
            this.postState.pageNo++
            if (this.postListArr.length === 0) {
              this.isNone = true
              this.postState.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    handleLike (item, index) {
      // if (rolesClick(this.rolesData, this.userInfo)) return
      if (`${item.isLike}` === '1') {
        delLike({ id: item.likeBaseId }).then(() => {
          this.postListArr[index].likeNum--
          this.$toast('取消点赞成功')
          this.postListArr[index].isLike = '2'
        })
        return
      }
      let params = {
        likeId: item.id,
        likeTitle: item.subjectName,
        userId: this.userInfo.id,
        targetUserId: item.userId,
        targetUserName: item.realName,
        targetHeadPic: item.headPicUrl,
        kind: '1'
      }
      if (item.contentFile && item.contentFile.length > 0) {
        params.cover = item.contentFile[0].url
      }
      if (item.areaPostbarLiveDTOS && item.areaPostbarLiveDTOS.length > 0) {
        params.cover = item.areaPostbarLiveDTOS[0].liveCover
      }
      if (item.coverInfo && item.coverInfo.url) {
        params.cover = item.coverInfo.url
      }
      postLike(params).then(res => {
        this.postListArr[index].likeNum++
        this.postListArr[index].likeBaseId = res.data
        this.postListArr[index].isLike = '1'
        this.$toast('点赞成功')
      })
    },
    handleClickItems (item, type) {
      let path = '/dccDetail'
      let query = type === 'comment' ? {
        postId: item.id,
        type: 'comment',
        areaId: this.$route.query.areaId,
        entrance: 53,
        channel: 53,
        businessId: this.$route.query.areaId,
      } : {
        postId: item.id,
        areaId: this.$route.query.areaId,
        entrance: 53,
        channel: 53,
        businessId: this.$route.query.areaId,
      }
      this.$router.push({
        path, query
      })
    },
    handleClickLive (item) {
      if (`${item.type}` === '1') {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.liveId}&businessId=${this.$route.query.areaId}&entrance=53&channel=53`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: item.liveId,
            businessId: this.$route.query.areaId,
            entrance: 53,
            channel: 53,
          },
        })
      } else {
        window.location.href = item.liveId
      }
    },
    handleClickItemsVideo (item, index) {
      this.postListArr[index].isPlayVideo = !item.isPlayVideo
      let params = {
        userId: this.userInfo.id,
        postbarId: item.id,
        subjectName: item.subjectName
      }
      visitAdd(params)
      setTimeout(() => {
        let videos = this.$refs.video
        for (let i in videos) {
          if (videos[i].playerVideo.id === item.id) {
            videos[i].player.play()
          }
        }
      })
    },
    handlePlay (e) {
      let videos = this.$refs.video
      for (let i in videos) {
        if (videos[i].playerVideo.id !== e.id) {
          videos[i].player.pause()
        }
      }
    },
    handleClickWork (item, type) {
      let path, query
      path = '/dccDetail'
      query = {
        postId: item.id,
        areaId: this.$route.query.areaId,
        entrance: 53,
        channel: 53,
        businessId: this.$route.query.areaId,
      }
      if (type === 'answerwork') {
        path = '/answerWork'
        query = {
          postId: item.id,
          areaId: this.areaId
        }
      }
      if (type === 'workdetails') {
        path = '/workDetails'
        query = {
          workId: item.areaPostbarWorkDTO[0].id,
          workType: 'answer',
          areaId: this.$route.query.areaId
        }
      }
      if (type === 'worklist') {
        path = '/workList'
        query = {
          postId: item.id,
          areaId: this.$route.query.areaId
        }
      }
      this.$router.push({
        path, query
      })
    }
  }
}
</script>
<style lang="less" scoped>
.section-block {
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
  padding: 0 16px 16px;
  box-sizing: border-box;
  min-height: calc(100vh - 260px);
}

.block1-list {
  .block1-item {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 12px;
    border: 1px solid #fff;
    box-sizing: border-box;
    position: relative;

    .icon-tag {
      width: 27px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-top {
      display: flex;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      /* 用户渐变 */
      background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);
      border-radius: 12px 12px 0 0;

      .top-cover {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 4px;
      }

      .top-con {
        display: flex;
        flex-direction: column;

        .txt1 {
          line-height: 20px;
          font-size: 14px;
          color: #EB1700;

          &.txt2 {
            color: #000000;
          }
        }

        .txt2 {
          display: flex;
          align-items: center;

          .txt2-tag {
            height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            border: 1px solid #EB1700;
            margin-right: 4px;
            color: #EB1700;
            font-size: 10px;
            padding: 0 4px;

            &.tag2 {
              border-color: #0F68B2;
              color: #0F68B2;
            }

            &.tag-user {
              color: #FF6017;
              border-color: #FF6017;
            }
            &.tag-admin {
            }
          }

          .txt2-time {
            font-size: 12px;
            font-weight: 500;
            color: #7a8494;
          }
        }
      }
    }

    .con-div {
      padding: 10px;
      padding-bottom: 0;
      box-sizing: border-box;

      .item-title {
        font-size: 14px;
        color: #202020;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 5px;
      }

      /deep/ .item-cons {
        font-size: 12px;
        color: #7a8494;
        margin-bottom: 4px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        h1, h2, h3, h4, h5, h6, p, span, strong, a { font-size: 100%; font-weight: normal; font-family: "Microsoft YaHei"; }
      }

      .item-imgs {
        display: flex;
        position: relative;
        flex-wrap: wrap;

        .bg-div {
          position: absolute;
          height: 77px;
          width: 100%;
          bottom: 0;
          left: 0;
          background: linear-gradient(360deg,
              rgba(0, 0, 0, 0.4) 0%,
              rgba(102, 102, 102, 0) 100%);
        }

        .items-con {
          display: flex;
          align-items: center;
          position: absolute;
          bottom: 8px;
          height: 40px;
          width: 100%;
          justify-content: space-between;
          padding: 0 8px;
          box-sizing: border-box;

          .con-txt {
            font-size: 14px;
            font-weight: 600;
            color: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
          }

          .con-btn {
            width: 56px;
            height: 24px;
            border-radius: 100px;
            background-color: #fff;
            font-size: 14px;
            color: #EB1700;
            font-weight: bold;
            text-align: center;
            line-height: 24px;
          }
        }

        .img-cover {
          width: 100px;
          margin-right: 10px;
          height: 100px;
          display: block;
          border-radius: 4px;
          object-fit: cover;

          &:nth-last-child(1) {
            margin-right: 0;
          }
        }

        .imgs-mask {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          height: 100px;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
        }

        .live-img-div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 182px;

          .video-cover {
            width: 100%;
            height: auto;
            object-fit: contain;
          }
        }

        .video-cover {
          width: 100%;
          height: 152px;
          object-fit: contain;
        }

        .icon-video {
          position: absolute;
          width: 40px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .video-block {
          width: 100%;
          height: 200px;

          .video-cover {
            display: block;
            width: 100%;
            height: 200px;
            position: relative;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          }
        }
      }

      .work-div {
        display: flex;
        align-items: center;
        padding-right: 10px;
        box-sizing: border-box;
        background: linear-gradient(180deg, #fff0ef 0%, #fff5ee 100%);
        border-radius: 4px;
        height: 32px;
        margin-top: 10px;

        &.worked {
          background: #f6f6f6;

          .work-btn {
            background: #dfdddd;
            color: #7a8494;
            box-shadow: none;
          }
        }

        .icon-word {
          width: 29px;
          height: 29px;
          display: block;
          margin-right: 4px;
          transform: translateY(2px);
        }

        .work-txt {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #202020;
          white-space: nowrap;
        }

        .work-go {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #EB1700;

          .txt {
            width: 180px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .icon-more {
            width: 13px;
            display: block;
            margin-left: 4px;
            transform: translateY(2px);
          }
        }

        .work-btn {
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
          border-radius: 30px;
          width: 44px;
          height: 18px;
          line-height: 18px;
          color: #fff;
          font-size: 12px;
          text-align: center;
        }

        .work-check {
          display: flex;
          align-items: center;
          height: 22px;

          .icon-check {
            display: block;
            width: 22px;
            height: 22px;
            transform: translateY(2px);
          }

          .check-txt {
            padding: 0 2px;
            box-sizing: border-box;
            font-size: 14px;
            color: #EB1700;
          }

          .icon-more {
            display: block;
            width: 12px;
            transform: translateY(2px);
          }
        }
      }

      .work-tip {
        margin-top: 10px;
        height: 20px;
        display: flex;
        justify-content: space-between;

        .left-txt {
          font-size: 13px;
          color: #7a8494;
        }

        .right-txt {
          font-size: 14px;
          color: #7a8494;
        }
      }

      .item-comment {
        background-color: #f6f6f6;
        padding: 10px 8px;
        box-sizing: border-box;
        margin-top: 10px;
        border-radius: 4px;

        .comment-block {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .head-cover {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            display: block;
          }

          .comment-txt {
            font-size: 12px;
            color: #343434;
            word-break: break-all;
          }
        }
      }
    }

    .item-btm {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .btm-flex {
        display: flex;
        align-items: center;
        height: 40px;

        .icon-btm1 {
          width: 16px;
          margin-right: 4px;
          display: block;
        }

        .btm-num {
          line-height: 40px;
          font-size: 12px;
          color: #7a8494;
          display: block;
        }
      }
    }
  }

  .vote-list {
    margin-top: 10px;
    .vote-show-div {
      overflow: hidden;
      height: 114px;
      &.auto {
        height: auto;
      }
    }

    .vote-item {
      width: 100%;
      padding: 6px 0;
      border: 1px solid #E8E8E8;
      box-sizing: border-box;
      margin-bottom: 6px;
      border-radius: 4px;
      color: #EB1700;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.item-submit {
        background-color: #EB1700;
        color: #fff;
        height: 32px;
        border-radius: 30px;
      }

      .process {
        width: 0;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      .txt-block {
        display: flex;
        align-items: center;
        .txt {
          position: relative;
          z-index: 1;
          max-width: 240px;
          margin-right: 10px;
        }
      }

      .num-txt {
        font-size: 14px;
        position: relative;
        z-index: 1;
      }

      &.item-checked {
        border-color: #EB1700;
        justify-content: space-between;
        padding-left: 14px;
        padding-right: 14px;
        position: relative;

        .process {
          background-color: rgba(255, 91, 12, 0.1);
        }

        .num-txt {
          color: #EB1700;
        }

        .icon-checked {
          width: 14px;
        }
      }

      &.item-not-checked {
        border-color: #E8E8E8;
        justify-content: space-between;
        padding-left: 14px;
        padding-right: 14px;
        position: relative;
        color: #333333;

        .process {
          background-color: #F6F6F6;
        }

        .num-txt {
          color: #333333;
        }
      }

      .icon-more {
        display: block;
        width: 4px;
        margin-left: 4px;
      }
    }
  }
}

/deep/ .empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/zoneList.vue